import ApiRequest from "@/helpers/ApiRequest";
import GetHeaders from "@/helpers/GetHeaders";
import { SAVE_ANALYSES } from "@/store/mutation-types";

export default {
  actions: {
    loadAnalyses: async ({ commit }) => {
      return ApiRequest.exploreGet("analyses", GetHeaders.dataHeaders()).then(
        res => {
          commit(SAVE_ANALYSES, { analyses: res.data });
        }
      );
    },
    saveAnalyse: ({ commit, dispatch, state }, payload) => {
      // Temp flow: load all analyses, append new analyse, and submit them all
      return dispatch("loadAnalyses").then(async () => {
        let allAnalyses = state.analyses;
        allAnalyses.push(payload.analyse);

        return ApiRequest.explorePost(
          "analyses",
          { analyses: allAnalyses },
          GetHeaders.dataHeaders()
        ).then(res => {
          commit(SAVE_ANALYSES, { analyses: res.data });
          dispatch("loadAnalyses");
        });
      });
    },
    saveAnalyses: ({ commit, dispatch }, payload) => {
      return ApiRequest.explorePost(
        "analyses",
        { analyses: payload },
        GetHeaders.dataHeaders()
      ).then(res => {
        commit(SAVE_ANALYSES, { analyses: res.data });
        dispatch("loadAnalyses");
      });
    },
    updateAnalyse: ({ dispatch, state }, payload) => {
      // Temp flow: load all analyses, find and replace analyse, and submit them all
      return dispatch("loadAnalyses").then(async () => {
        let allAnalyses = state.analyses;
        const analyseIndex = allAnalyses.findIndex(
          a => a._id === payload.analyseId
        );
        allAnalyses[analyseIndex] = payload.analyse;

        return ApiRequest.explorePost(
          "analyses",
          { analyses: allAnalyses },
          GetHeaders.dataHeaders()
        ).then(() => {
          dispatch("loadAnalyses");
        });
      });
    },
    deleteAnalyse: ({ dispatch, state }, payload) => {
      return dispatch("loadAnalyses").then(async () => {
        let allAnalyses = state.analyses;
        const analyseIndex = allAnalyses.findIndex(
          a => a._id === payload.analyseId
        );
        allAnalyses.splice(analyseIndex, 1);

        return ApiRequest.explorePost(
          "analyses",
          { analyses: allAnalyses },
          GetHeaders.dataHeaders()
        ).then(() => {
          dispatch("loadAnalyses");
        });
      });
    },
    reduceDimensions: (_, payload) => {
      return ApiRequest.explorePost(
        "dimension_reduction",
        { dimensions: payload.dimensions, n_neighbors: payload.n, n_clusters: payload.c},
        GetHeaders.dataHeaders()
      ).then(res => {
        return res.data;
      });
    },
    getItemData: async (_, payload) => {
      return ApiRequest.explorePost("itemdata", {layers: payload},  GetHeaders.dataHeaders()).then(
        res => {
          return res.data;
        }
      );
    },
  },
  getters: {
    analyseById: state => payload =>
      state.analyses.find(a => a._id === parseInt(payload.id))
  },
  mutations: {
    [SAVE_ANALYSES](state, payload) {
      state.analyses = payload.analyses;
    }
  },
  state: {
    analyses: []
  }
};
